export default /* glsl */ `vec4 getMask(vec4 xyzw) {
  return vec4(1.0);
}`;
